
        window.pug_templates['multipar_bids'] = window.pug_mixins['multipar_bids'] = function(type, auction) {
          var pug_interp, attributes = this.attributes || {}, block = this.block || false;
          window.pug_mixin_level++;
      const { lots, bids = [] } = auction;
let count = 0;

bids.sort((a, b) => {
  if (type === 'history' || a.lots.length === b.lots.length) {
    return a.placed_at === b.placed_at ? 0 : a.placed_at < b.placed_at ? 1 : -1;
  }

  return a.lots.length < b.lots.length ? 1 : -1;
});


pug_html = pug_html + "\u003Ctable class=\"table table-striped\"\u003E\u003Ccolgroup\u003E \u003Ccol style=\"width: 1px;\"\u002F\u003E\u003Ccol style=\"width: 35%;\"\u002F\u003E\u003Ccol style=\"width: 35%;\"\u002F\u003E\u003Ccol style=\"width: 30%;\"\u002F\u003E\u003C\u002Fcolgroup\u003E\u003Cthead\u003E \u003Ctr\u003E \u003Cth colspan=\"2\"\u003EParcels \u003C\u002Fth\u003E\u003Cth\u003EBidder \u003C\u002Fth\u003E\u003Cth class=\"text-right\"\u003EBid \u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate bids
;(function(){
  var $$obj = bids;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var bid = $$obj[pug_index1];
if ((type === 'winning' && bid.is_winner) || (type === 'combos' && bid.is_top && bid.lots.length > 1) || (type === 'history' )) {
count++;
pug_html = pug_html + "\u003Ctr" + (pug.attr("data-lots", bid.lots, true, false)) + "\u003E\u003Ctd\u003E";
if (bid.is_winner) {
pug_html = pug_html + "\u003Ci class=\"fa fa-check text-success\" data-tooltip=\"data-tooltip\" data-content=\"This is a winning bid\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv class=\"lots\"\u003E\u003Ci class=\"fa fa-gavel mr-2\"\u003E\u003C\u002Fi\u003E\u003Ca class=\"lot\"\u003E" + (pug.escape(null == (pug_interp = bid.lots.map(id => { return 'Parcel ' + lots.find(l => l.id === id).parcel_number; }).join(', ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug.escape(null == (pug_interp = bid.user.username) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"text-right\"\u003E\u003Cdiv class=\"text-strong\"\u003E" + (pug.escape(null == (pug_interp = Utils.toCurrency(bid.amount)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (auction.has_per_units) {
pug_html = pug_html + "\u003Cdiv class=\"small\"\u003E" + (pug.escape(null == (pug_interp = `(${Utils.toCurrency(bid.per_unit_amount)}/${auction.parcel_unit})`) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (type === 'history') {
pug_html = pug_html + "\u003Cdiv class=\"small text-muted mt-2\"\u003E" + (pug.escape(null == (pug_interp = $.DateFns.format(bid.placed_at * 1000, `'at' h:mm:ss a 'on' MM/dd/yyyy`)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var bid = $$obj[pug_index1];
if ((type === 'winning' && bid.is_winner) || (type === 'combos' && bid.is_top && bid.lots.length > 1) || (type === 'history' )) {
count++;
pug_html = pug_html + "\u003Ctr" + (pug.attr("data-lots", bid.lots, true, false)) + "\u003E\u003Ctd\u003E";
if (bid.is_winner) {
pug_html = pug_html + "\u003Ci class=\"fa fa-check text-success\" data-tooltip=\"data-tooltip\" data-content=\"This is a winning bid\"\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv class=\"lots\"\u003E\u003Ci class=\"fa fa-gavel mr-2\"\u003E\u003C\u002Fi\u003E\u003Ca class=\"lot\"\u003E" + (pug.escape(null == (pug_interp = bid.lots.map(id => { return 'Parcel ' + lots.find(l => l.id === id).parcel_number; }).join(', ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug.escape(null == (pug_interp = bid.user.username) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"text-right\"\u003E\u003Cdiv class=\"text-strong\"\u003E" + (pug.escape(null == (pug_interp = Utils.toCurrency(bid.amount)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (auction.has_per_units) {
pug_html = pug_html + "\u003Cdiv class=\"small\"\u003E" + (pug.escape(null == (pug_interp = `(${Utils.toCurrency(bid.per_unit_amount)}/${auction.parcel_unit})`) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (type === 'history') {
pug_html = pug_html + "\u003Cdiv class=\"small text-muted mt-2\"\u003E" + (pug.escape(null == (pug_interp = $.DateFns.format(bid.placed_at * 1000, `'at' h:mm:ss a 'on' MM/dd/yyyy`)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
    }
  }
}).call(this);

if (count === 0) {
pug_html = pug_html + "\u003Ctr\u003E \u003Ctd class=\"p-3 text-center small\" colspan=\"5\"\u003E" + (pug.escape(null == (pug_interp = `There are currently no ${type === 'winning' ? `${type} bids` : type === 'combos' ? 'combo bids' : 'bids'}`) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E";

          window.pug_mixin_level--;
          if (window.pug_mixin_level < 1) { var result = pug_html; pug_html=""; return result; }
        };
      